import api from "../../Hooks/axiosApi";



// ---------- Screen 1: Members list ----------
export const getOperatorCompaniesService = (params: {
    searchText?: string;
    isActive?: boolean;
}) => {
    return api.get("/api/platform/operator/companies", { params });
};

// ---------- Screen 2: Member detail ----------
export const getOperatorCompanyByIdService = (companyId: number | string) => {
    return api.get(`/api/platform/operator/companies/${companyId}`);
};

// Optional helper if you need to refresh just the staff table after a toggle
export const getOperatorCompanyStaffService = (companyId: number | string) => {
    return api.get(`/api/platform/operator/companies/${companyId}/staff`);
};

export const updateOperatorCompanyStatusService = ({
    companyId,
    isActive,
}: {
    companyId: number | string;
    isActive: boolean;
}) => {
    return api.put(`/api/platform/operator/companies/${companyId}/status`, null, {
        params: { isActive },
    });
};

export const updateOperatorStaffStatusService = ({
    staffId,
    isActive,
}: {
    staffId: number | string;
    isActive: boolean;
}) => {
    return api.put(`/api/platform/operator/staff/${staffId}/status`, null, {
        params: { isActive },
    });
};

// ---------- Screen 3: Create member ----------
export const createOperatorMemberService = (data: {
    businessName: string;
    acn?: string;
    contactName?: string;
    contactMobile?: string;
    contactEmail?: string;
    bookingLink?: string;
    brandColorPrimary?: string;
    brandColorSecondary?: string;
    firstName: string;
    surname: string;
    mobile?: string;
    email: string;
    isActive?: boolean;
}) => {
    return api.post("/api/platform/operator/members", data);
};

// ---------- Screen 4: EOIs ----------
export const getOperatorEoisService = (params: {
    fromDate?: string;
    toDate?: string;
    companyId?: number | string;
}) => {
    return api.get("/api/platform/operator/eois", { params });
};

// ---------- Usage counts (used behind a date-range picker on Screen 2) ----------
export const getOperatorUsageService = (
    companyId: number | string,
    params: { fromDate?: string; toDate?: string }
) => {
    return api.get(`/api/platform/operator/usage/${companyId}`, { params });
};
// ---------- StateName in the searches table ----------

export const getPlatformStatesService = () => api.get("/api/platform/suburbs/states");


// ---------- Operator Company Search (searches table below EOIs on Member Detail) ----------
export const getOperatorSearchesService = (params: {
    companyId?: number | string;
    fromDate?: string;
    toDate?: string;
    pageNumber?: number;
    pageSize?: number;
}) => {
    return api.get("/api/platform/operator/searches", { params });
};

// ---------- Optional admin tools ----------
export const sendOperatorTestEmailService = (to: string) => {
    return api.post("/api/platform/operator/test-email", null, { params: { to } });
};

export const getOperatorHealthReadyService = () => {
    return api.get("/api/platform/health/ready");
};